import React from 'react';
import { Link } from 'react-router-dom';
import { Nav } from 'rsuite';

export default props => <Nav.Item componentClass={Link} {...props} />;
